import { useState, useRef, Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Col, Form, Table } from 'react-bootstrap';
import { List } from 'react-bootstrap-icons';
import momentJalaali from "moment-jalali";
import DatePicker from 'react-datepicker2';
import { useSelector } from 'react-redux';
import NewNumberInput from '../../../Components/NewNumberInput';
import { setDialog } from "../../store/api/GetAllProduct";
import { getServiceReferral, saveServiceRefferal, deleteServiceReferral } from "../../store/api/TaskDetailsApi";
import TableRow from '../../../Components/TableRow';
import Loader from 'react-loader-spinner';
import { getStaffShare } from '../../store/api/Services';
function ServiceReferrals(props) {
    const { staffReportList, serviceInfo, setServiceInfo, setPopSelectStaff, parentStaffID, sendSMSToCustomer } = props;
    const { fieldList, refers, systemSettings } = useSelector(state => {
        return {
            fieldList: state.UserReducer.pageFieldList,
            refers: state.taskDetails.refers, systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const [selectedStaff, setStaffData] = useState(null);
    const [eventDate, setEventDate] = useState(null);
    const [isStaffEmpty, setStaffEmpty] = useState(null);
    const [priceValues, setPriceValues] = useState({ TaxAmount: 0, PureTotalPrice: 0, StaffShare: 0 });
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const staffSharesInfo = {
        StaffTransportationPercentShare: selectedStaff?.StaffTransportationPercentShare ?? serviceInfo.StaffTransportationPercentShare,
        StaffTransportationFixAmountShare: selectedStaff?.StaffTransportationFixAmountShare ?? serviceInfo.StaffTransportationFixAmountShare
    }
    const [refData, setRefData] = useState({});
    const dispatch = useDispatch();
    const checkFieldPermission = (fieldName, actionType) => {
        let result = actionType === "Read";
        let field = fieldList?.find(f => f.PageName === "Service_Referral" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    }
    const handleChange = (e) => {
        refData.StaffReportID = e.target.value;
        setRefData({ ...refData, ReferralDesc: Number(e.target.value) ? e.target.options[e.target.selectedIndex].text : "" });

    }
    const saveReferral = () => {
        let staffID = document.getElementById("RF_StaffID")?.value;
        if (staffID === '') {
            setStaffEmpty(true);
            return;
        }
        else {
            setStaffEmpty(false);
        }
        if (staffID) {
            refData.RF_StaffID = staffID;
        }
        if (!refData.IsGarauntee) {
            refData.IsGarauntee = false;
        }
        if (!refData.RF_TransportationCost) {
            refData.RF_TransportationCost = 0;
        }
        if (!refData.RowDiscount) {
            refData.RowDiscount = 0;
        }
        refData.strServiceType = serviceInfo.ServiceType;
        refData.serviceID = serviceInfo.ServiceID;
        refData.EventDate = eventDate ?? new Date();
        if (!refData.ReferralDesc) {
            refData.ReferralDesc = "";
        }
        if (!refData.StaffReportID || refData.StaffReportID === "0") {
            refData.StaffReportID = staffReportList.find(s => s.SelectedServiceStatusID === 4)?.ID;
            if (!refData.StaffReportID) {
                refData.StaffReportID = staffReportList.find(s => s.StaffReportCode === "ok")?.ID;
            }
        }

        dispatch(saveServiceRefferal(refData, (res) => {
            setRefData({});
            setPriceValues({ TaxAmount: 0, PureTotalPrice: 0, StaffShare: 0 });
            document.getElementsByName("ReferralDesc")[0].value = 1;
            const elCost = document.getElementsByName("RF_TransportationCost")[0];
            if (elCost) {
                elCost.value = 0;
                elCost.parentNode.setAttribute("comma-value", 0);
            }
            const elDiscount = document.getElementsByName("RowDiscount")[0];
            if (elDiscount) {
                elDiscount.value = 0;
                elDiscount.parentNode.setAttribute("comma-value", 0);
            }
            const elTaxPercent = document.getElementsByName('TaxPercent')[0];
            if (elTaxPercent) {
                elTaxPercent.value = 0;
            }

            serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
            serviceInfo.TaxAmount = res.TaxAmount;
            serviceInfo.Discount = res.Discount;
            if (selectedStaff) {
                serviceInfo.StaffUsedPartsCostPercentShare = selectedStaff.StaffUsedPartsCostPercentShare;
                serviceInfo.StaffUsedPartsCostFixAmountShare = selectedStaff.StaffUsedPartsCostFixAmountShare;
                serviceInfo.StaffExtraUsedPartsCostPercentShare = selectedStaff.StaffExtraUsedPartsCostPercentShare;
                serviceInfo.StaffExtraUsedPartsCostFixAmountShare = selectedStaff.StaffExtraUsedPartsCostFixAmountShare;
            }
            setServiceInfo({ ...serviceInfo });
            const reportID = staffReportList.find(s => s.SelectedServiceStatusID === 4)?.ID;
            if (refData.StaffReportID == reportID) {
                serviceInfo.Status = "موفق";
                serviceInfo.StatusName = "done";
                sendSMSToCustomer();
            }
            //dispatch(getServiceReferral(serviceInfo.ServiceID, serviceInfo.ServiceType));
        }));
    }
    function onDelete(res) {
        serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
        serviceInfo.TaxAmount = res.TaxAmount;
        serviceInfo.Discount = res.Discount;
        setServiceInfo({ ...serviceInfo });
    }
    function onPriceChanged(name, value) {
        if (!value || value === "") {
            value = 0;
        }
        refData[name] = Number(value);
        if (name === "RF_StaffShare") {
            setPriceValues({ ...priceValues, StaffShare: Number(value) });
            return;
        }
        if (!refData.RF_TransportationCost) {
            refData.RF_TransportationCost = 0;
        }
        if (!refData.RowDiscount) {
            refData.RowDiscount = 0;
        }
        if (!refData.TaxPercent) {
            refData.TaxPercent = 0;
        }
        const staffShare = getStaffShare(staffSharesInfo, "referral", refData.RowDiscount, refData.RF_TransportationCost, systemSettings, serviceInfo.ReceptionInAgent, serviceInfo.AgencyID);
        refData.RF_StaffShare = staffShare;
        refData.TaxAmount = (Number(refData.RF_TransportationCost) - Number(refData.RowDiscount)) * Number(refData.TaxPercent) / 100;
        setPriceValues({
            TaxAmount: refData.TaxAmount, StaffShare: staffShare,
            PureTotalPrice: Number(refData.RF_TransportationCost) - Number(refData.RowDiscount) + refData.TaxAmount
        })
    }
    const tableColes = [
        { colTitle: "نام تکنسین", colName: "StaffName", justInMobile: true },
        { colTitle: "تاریخ مراجعه", colName: "DueDate+EndTime", justInMobile: true, colType: "string" },
        { colTitle: "وضعیت", colName: "ResultStr", justInMobile: true },
        { colTitle: "شرح مراجعه", colName: "ReferralDesc" },
        { colTitle: "ایاب و ذهاب", colName: checkFieldPermission("UnitPrice", "Read") ? "TransportationCost" : "", colType: "currency" },
        { colTitle: "تخفیف", colName: checkFieldPermission("Discount", "Read") ? "RefferalDiscount" : "", colType: "currency" },
        { colTitle: "مالیات", colName: checkFieldPermission("Tax", "Read") ? "TaxAmount" : "", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", colType: "currency" },
        { colTitle: "سهم تکنسین", colName: checkFieldPermission("StaffShare", "Read") ? "RefferalStaffShare" : "", colType: "currency" },
        { colTitle: "گارانتی", colName: "IsGuarantee", colType: "boolean" }
    ]
    const tableRowButtons = [
        {
            title: "حذف مراجعه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                if (serviceInfo.IsArchive !== true && !serviceInfo.IsNotLastDuration) {
                    dispatch(setDialog({
                        status: 'show',
                        arrayBtn: ['yes', 'no'],
                        dialogTitle: 'حذف ایاب و ذهاب',
                        dialogText: 'آیا از حذف مطمئن هستید؟',
                        okOperation: deleteServiceReferral(item.RefferalID, serviceInfo.ServiceType, (res) => onDelete(res))
                    }))
                }
            }
        }
    ]
    function onInputFocus(e) {
        e.target.select();
    }
    function showModalStaff() {
        const onSelect = (data) => {
            staffSharesInfo.StaffTransportationPercentShare = data?.StaffTransportationPercentShare;
            staffSharesInfo.StaffTransportationFixAmountShare = data?.StaffTransportationFixAmountShare;
            setStaffData(data);
        }
        setPopSelectStaff({ show: true, onSelect: onSelect, parentID: parentStaffID });
    }
    useEffect(() => {
        if (Number(serviceInfo?.ServiceID) > 0) {
            dispatch(getServiceReferral(serviceInfo.ServiceID, serviceInfo.ServiceType));
        }
    }, [])
    return (
        <Fragment>

            {serviceInfo.IsArchive !== true && !serviceInfo.IsNotLastDuration &&
                <Fragment>
                    <div className='row'>
                        <div className="form-group col-md-2">
                            <label> تاریخ مراجعه </label>
                            <DatePicker name="EventDate" isGregorian={false} timePicker={true} className="form-control" value={eventDate ? momentJalaali(eventDate) : momentJalaali()}
                                onChange={value => { setEventDate(value.local("en").format("YYYY-MM-DD HH:mm")); }} inputJalaaliFormat='jYYYY/jMM/jDD HH:mm' />
                        </div>
                        {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                            <div className='form-group  col-md-2'>
                                <label>تکنسین مراجعه کننده:</label>
                                <input type='hidden' id="RF_StaffID" value={selectedStaff ? selectedStaff.ID : serviceInfo?.StaffID ?? ""} readOnly />
                                <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control' value={selectedStaff ? selectedStaff.LastName : serviceInfo?.StaffName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalStaff}><List size={20} /></Button>
                                {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                            </div>
                        }
                        {staffReportList && Array.isArray(staffReportList) &&
                            <div className="form-group col-md-2">
                                <label>وضعیت</label>
                                <select className="form-control" name="ReferralDesc" defaultValue={1} onChange={handleChange}>
                                    <option value="" createreferral="true">انتخاب کنید</option>
                                    {staffReportList.map((item, i) => { return (<option key={i} value={item.ID}>{item.StaffReportDescription}</option>) })}
                                </select>
                            </div>
                        }
                        <Col md={2} className='form-group'>
                            <label>شرح مراجعه</label>
                            <Form.Control value={refData?.ReferralDesc ?? ""} onChange={e => setRefData({ ...refData, ReferralDesc: e.target.value })} />
                        </Col>
                    </div>

                    <div className="row">
                        <Fragment>
                            <div className='form-group  col-md-2'>
                                <label>وضعیت گارانتی: </label>
                                <select className='form-control' id="IsRefGuaranty" onChange={(e) => { refData.IsGarauntee = e.target.value }} defaultValue={false}>
                                    <option value={false} style={{ color: "red" }}>شامل گارانتی نیست</option>
                                    <option value={true} style={{ color: "#008058" }}>شامل گارانتی است</option>
                                </select>
                            </div>
                            {checkFieldPermission("UnitPrice", "Read") &&
                                <div className="form-group col-md-2">
                                    <label>مبلغ ایاب و ذهاب</label><span style={{ color: "red" }}>*</span>
                                    <NewNumberInput inputname="RF_TransportationCost" readonly={checkFieldPermission("UnitPrice", "Edit")} onChange={(e) => onPriceChanged("RF_TransportationCost", e.target.value)} />
                                </div>
                            }
                            {checkFieldPermission("Discount", "Read") &&
                                <div className="form-group col-md-2">
                                    <label>تخفیف</label>
                                    <NewNumberInput inputname="RowDiscount" readonly={checkFieldPermission("Discount", "Edit")} onChange={(e) => onPriceChanged("RowDiscount", e.target.value)} minvalue={0} />
                                </div>
                            }
                            {checkFieldPermission("Tax", "Read") &&
                                <Col md={2} className="form-group">
                                    <div style={{ width: "30%", display: "inline-block" }}>
                                        <label className='ellipsisLabel' title='درصد مالیات'>% مالیات</label>
                                        <Form.Control type='number' name="TaxPercent" defaultValue={0} readOnly={checkFieldPermission("Tax", "Edit")} onFocus={onInputFocus}
                                            onChange={(e) => onPriceChanged("TaxPercent", e.target.value)} minvalue={0} style={{ borderRadius: "0px 4px 4px 0px" }} />
                                    </div>
                                    <div style={{ width: "70%", display: "inline-block" }}>
                                        <label>مالیات</label>
                                        <NewNumberInput inputname="TaxAmount" readonly={true} value={priceValues.TaxAmount}
                                            style={{ borderRadius: "4px 0px 0px 4px", marginRight: "1px" }} />
                                    </div>
                                </Col>
                            }
                            <Col md={2} className='form-group'>
                                <label>قابل پرداخت: </label>
                                <NewNumberInput readonly={true} value={priceValues.PureTotalPrice} />
                            </Col>
                            <Col md={2} className='form-group'>
                                <label>سهم تکنسین: </label>
                                <NewNumberInput value={priceValues.StaffShare ?? 0} readonly={checkFieldPermission("StaffShare", "Edit")} onChange={(e) => onPriceChanged("RF_StaffShare", e.target.value)} />

                            </Col>
                        </Fragment>

                    </div>
                    <button type="button" className="btn btn-primary btn-block group-Btn mt-2" onClick={saveReferral}>ثبت ایاب و ذهاب</button>
                </Fragment>
            }
            <Table responsive={true} className="mt-3">
                <thead>
                    <tr>
                        <th>نام تکنسین</th>
                        <th>تاریخ مراجعه</th>
                        <th>وضعیت</th>
                        {window.innerWidth > 414 &&
                            <Fragment>
                                <th>شرح مراجعه</th>
                                <th>ایاب و ذهاب</th>
                                <th>تخفیف</th>
                                <th>مالیات</th>
                                <th>قابل پرداخت</th>
                                <th>سهم تکنسین</th>
                                <th>گارانتی</th>
                                <th></th>
                            </Fragment>
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        refers === "PENDING" &&
                        <tr><td style={{ textAlign: "center" }} colSpan={11}><Loader type="BallTriangle" color="#bb1370" height={25} width={25} /></td></tr>
                    }
                    {refers && Array.isArray(refers) &&
                        refers.map((item, i) => <TableRow key={i} row={item} buttons={tableRowButtons} indx={i} cols={tableColes} />)
                    }
                </tbody>
            </Table>
        </Fragment>
    )
}
export default ServiceReferrals;